const DeletePeriod = 120;
const API = 'https://rnd.mypubs.ru/api.php';
const Forms = [
    "\u043E\u0442\u0437\u044B\u0432",
    "\u043E\u0442\u0437\u044B\u0432\u0430",
    "\u043E\u0442\u0437\u044B\u0432\u043E\u0432"
];
const Command = {
    RATING: 'rating',
    LOAD: 'load',
    ADD: 'add',
    DELETE: 'delete'
};
var debug = false;
function getBarStatus(container) {
    const worklist = container.data('worklist').split(';;;').filter(Boolean);
    const days = [
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431",
        "\u0432\u0441"
    ];
    const now = new Date();
    const currentDay = (now.getDay() + 6) % 7;
    const currentMinutes = currentDay * 1440 + now.getHours() * 60 + now.getMinutes();
    let isOpen = false;
    let closesInMinutes = Infinity;
    worklist.forEach((item)=>{
        const [dayRange, timeRange] = item.split('|');
        const [openTime, closeTime] = timeRange.split(/\s*[–-]\s*/).map((time)=>{
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
        });
        const range = dayRange.toLowerCase().split(/\s*[–-]\s*/);
        const startDay = days.indexOf(range[0]);
        const endDay = days.indexOf(range[1] || range[0]);
        const dayCount = (endDay - startDay + 7) % 7 + 1;
        for(let dayOffset = 0; dayOffset < dayCount; dayOffset += 1){
            const openingDay = (startDay + dayOffset) % 7;
            const openingMinutes = openingDay * 1440 + openTime;
            const closingMinutes = openingMinutes + (closeTime <= openTime ? 1440 - openTime + closeTime : closeTime - openTime);
            if (currentMinutes >= openingMinutes && currentMinutes < closingMinutes) {
                isOpen = true;
                closesInMinutes = Math.min(closesInMinutes, closingMinutes - currentMinutes);
            }
        }
    });
    const isClosingSoon = isOpen && closesInMinutes <= 60;
    return {
        isClosingSoon,
        isOpen
    };
}
function stars(rating) {
    var value = Math.min(5, Math.max(0, Number(rating) || 0));
    var full = Math.floor(value);
    var half = value - full >= 0.5 ? 1 : 0;
    var empty = 5 - full - half;
    return '<i class="fa-solid fa-star"></i>'.repeat(full) + '<i class="fa-solid fa-star-half-stroke"></i>'.repeat(half) + '<i class="fa-regular fa-star"></i>'.repeat(empty);
}
function addRating(sum, count, item) {
    if (count === 0 || sum === undefined || sum === 0) {
        $(item).html(`${window.mypubs.stars(0)}`);
        $(item).attr('value', '-1');
        return;
    }
    var avg = sum / count;
    $(item).html(`${window.mypubs.stars(avg)} ${avg.toFixed(1)}`);
    $(item).attr('value', avg.toFixed(1));
}
function getRating(url, container) {
    $.post(API, {
        url,
        cmd: Command.RATING
    }).done(function(data) {
        if (debug) console.log(data);
        if (data.length === 0) window.mypubs.addRating(0, 0, container);
        else {
            var info = JSON.parse(data);
            window.mypubs.addRating(info.sum, info.count, container);
        }
    }).fail(function(data) {
        if (debug) console.error(data);
        window.mypubs.addRating(0, 0, container);
    });
}
function setMaps() {
    var list = $('article');
    list.each(function(index, item) {
        var name = $(item).find('.bar-title a').text();
        var icon = $(item).find('.map-marker').data('src');
        var location = $(item).find('.map-location').val();
        if (location) {
            const frame = $(item).find('.map-frame');
            const [lat, lng] = location.split(',').map(Number);
            const map = L.map(frame[0]).setView([
                lat,
                lng
            ], 15);
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OSM'
            }).addTo(map);
            const marker = icon ? L.icon({
                iconUrl: icon,
                iconSize: [
                    40,
                    40
                ],
                iconAnchor: [
                    20,
                    40
                ],
                popupAnchor: [
                    0,
                    -40
                ]
            }) : new L.Icon.Default();
            L.marker([
                lat,
                lng
            ], {
                icon: marker
            }).addTo(map).bindPopup(name);
            $(item).data('leaflet-map', map);
            $(item).find('.leaflet-control-attribution a, .leaflet-control-attribution span').hide();
        }
    });
    refreshMaps();
}
function refreshMaps() {
    $('article:visible').each(function() {
        const map = $(this).data('leaflet-map');
        if (map) setTimeout(()=>{
            map.invalidateSize();
        }, 0);
    });
}
function setRatings() {
    var list = $('article');
    list.each(function(index, item) {
        var container = $(item).find('.bar-rating');
        var url = $(item).find('.bar-title a').attr('href');
        if (url) getRating(url, container);
    });
}
function setStatuses() {
    var list = $('article');
    list.each(function(index, item) {
        var status = $(item).find('.bar-hours');
        if (status.length > 0) {
            var info = getBarStatus(status);
            $(status).html(info.isClosingSoon ? "\u0421\u043A\u043E\u0440\u043E \u0437\u0430\u043A\u0440\u043E\u0435\u0442\u0441\u044F" : info.isOpen ? "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u0441\u0435\u0439\u0447\u0430\u0441" : "\u0417\u0430\u043A\u0440\u044B\u0442\u043E");
        }
    });
}
(function($1) {
    function setActiveFilter() {
        var links = $1('.filter-row-left .filter-btn[href], .filter-row-left .filter-dropdown-item[href]');
        if (links.length === 0) return;
        var current = window.location.pathname.replace(/index\.html$/, '') || '/';
        links.each(function() {
            var link = $1(this);
            var linkPath = new URL(link.attr('href'), window.location.origin).pathname.replace(/index\.html$/, '') || '/';
            var isHome = current === '/' && linkPath === '/pubs/';
            var isPaginated = linkPath === '/pubs/' && current.indexOf('/pubs/') === 0;
            link.toggleClass('is-active', linkPath === current || isHome || isPaginated);
        });
        $1('#filter-more-toggle').toggleClass('is-active', $1('.filter-dropdown-menu .is-active').length > 0);
    }
    function setFilterDropdown() {
        var dropdown = $1('#filter-more');
        if (dropdown.length === 0) return;
        var toggle = dropdown.find('#filter-more-toggle');
        toggle.on('click', function(e) {
            e.stopPropagation();
            var isOpen = dropdown.toggleClass('is-open').hasClass('is-open');
            toggle.attr('aria-expanded', isOpen);
        });
        $1(document).on('click', function(e) {
            if (!$1(e.target).closest(dropdown).length) {
                dropdown.removeClass('is-open');
                toggle.attr('aria-expanded', false);
            }
        });
        $1(document).on('keydown', function(e) {
            if (e.key === 'Escape') {
                dropdown.removeClass('is-open');
                toggle.attr('aria-expanded', false);
            }
        });
    }
    setRatings();
    setStatuses();
    setMaps();
    setActiveFilter();
    setFilterDropdown();
})(jQuery);
window.mypubs = window.mypubs || {};
window.mypubs.getBarStatus = getBarStatus;
window.mypubs.stars = stars;
window.mypubs.addRating = addRating;
window.mypubs.getRating = getRating;
window.mypubs.setMaps = setMaps;
window.mypubs.refreshMaps = refreshMaps;
window.mypubs.setRatings = setRatings;
window.mypubs.setStatuses = setStatuses;

//# sourceMappingURL=scripts.7baf2094.js.map
